export default function () {
  return {
    modalSubordinate: false,
    menuSide: false,
    sidebar: false,
    sideDev: false,
    sideSettingActivity: false,
    sideSettingProspek: false,
    sideSettingCustomer: false,
    sideSettingEmployee: false,
    prompt: false,
    screenWidth: 0,
    notif: false
  }
}
